import { Navigate, Outlet } from "react-router-dom";
import React from "react";
import { LoginServices } from "../services/LoginServices";
import SideBar from "../components/SideBar/SideBar";


const ProtectedRoute = () => {
  return (
    LoginServices.verifySession() ? <div className="flex flex-row h-full"><SideBar /><Outlet /> </div> : <Navigate to="/login" replace />
  );
}
export default ProtectedRoute;